import { render, staticRenderFns } from "./abnormaldetails.vue?vue&type=template&id=cc63950a&scoped=true&"
import script from "./abnormaldetails.vue?vue&type=script&lang=js&"
export * from "./abnormaldetails.vue?vue&type=script&lang=js&"
import style0 from "./abnormaldetails.vue?vue&type=style&index=0&id=cc63950a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc63950a",
  null
  
)

export default component.exports